export default __webpack_public_path__ + "static/cards-mobile-min-4cba7de396b835d7ff293d2b447e20a2.png";